import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { Option } from "antd/es/mentions";
import { useMutation, useQuery } from "@tanstack/react-query";
import useProjectWiseClientList from "../../../components/hooks/useProjectWiseClientList";
import {
  clientProgressDataWithStatus,
  getLockedStatus,
  getProjectInfoById,
  getVersionList,
  versioningLockUnlock,
} from "../../../api/apiCallManager";
import { useParams } from "react-router-dom";
import useProjectInfoQuery from "../../../components/hooks/useProjectInfoQuery";
import AccessTo from "../../../components/is-show/AccessTo";
import { CM, FL, PA } from "../../router/AddRoutesJson";
import CreateVersion from "./CreateVersion";
import Loader from "../../../components/spinner/Loader";
import useVersionStore from "./../../../components/hooks/useVersionStore";

function VersionLockUnlock() {
  // Fetch client data using custom hook
  const { latestVersion, setLatestVersion } = useVersionStore(); // Zustand store

  const { id } = useParams();
  const [isLoading, setIsLoading] = useState({
    lock: false,
    unlock: false,
    upgrade: false,
  });
  const [isDisabled, setIsDisable] = useState({
    lock: false,
    unlock: false,
    upgrade: false,
  });
  const {
    data: clientData,
    isLoading: isClientDataLoading,
    isFetching: isClientDataFetching,
  } = useProjectWiseClientList();
  const {
    data: projectInfoData,
    error: projectInfoErro,
    isLoading: projectInfoLoading,
  } = useProjectInfoQuery(id, getProjectInfoById);
  // Prepare the filtered data
  const filteredData = clientData?.map(({ clientName, region }) => ({
    clientName,
    region,
  }));
  const filteredDataWithSite = clientData?.map(
    ({ clientName, region, siteManager }) => ({
      clientName,
      region,
      siteManager,
    })
  );
  const { data: lockedStatus } = useQuery({
    queryKey: ["lockedStatus__", filteredDataWithSite],
    queryFn: () =>
      getLockedStatus({
        clients: filteredDataWithSite,
        projectKey: projectInfoData?.project_key,
      }),
  });
  const { data: versionList } = useQuery({
    queryKey: ["versionList__"],
    queryFn: () =>
      getVersionList({
        clients: filteredData,
        projectKey: projectInfoData?.project_key,
      }),
    enabled: Boolean(projectInfoData?.project_key) && Boolean(filteredData),
  });

  // Define a mutation function for locking/unlocking
  const mutation = useMutation({
    mutationFn: versioningLockUnlock,
    onSuccess: (data, variables) => {
      console.log("API call successful:", data);
      const { event_type } = variables; // Access the event_type from the payload
      setIsDisable((prev) => ({
        ...prev,
        [event_type]: true, // Update only the specific event type
      }));
      setIsLoading((prev) => ({
        ...prev,
        [event_type]: false,
      }));
    },
    onError: (error) => {
      console.error("API call failed:", error);
    },
  });

  const handleChange = (value) => {
    console.log(`Selected: ${value}`);
  };

  const handleLock = () => {
    const payload = {
      event_type: "lock",
      clients: filteredData,
      projectKey: projectInfoData?.project_key,
    };

    setIsLoading((prev) => ({
      ...prev,
      lock: true,
    }));
    mutation.mutate(payload);
  };

  const handleUnlock = () => {
    const payload = {
      event_type: "unlock",
      clients: filteredData,
      projectKey: projectInfoData?.project_key,
    };
    setIsLoading((prev) => ({
      ...prev,
      unlock: true,
    }));
    mutation.mutate(payload);
  };

  const handleUpgrade = () => {
    const payloadUpgrade = {
      event_type: "upgrade",
      clients: filteredData,
      projectKey: projectInfoData?.project_key,
    };
    setIsLoading((prev) => ({
      ...prev,
      upgrade: true,
    }));
    mutation.mutate(payloadUpgrade);
  };
  const { data: clientProgressData } = useQuery({
    queryKey: ["clientProgressDataWithStatus_clientProgressDataWithStatus_"],
    queryFn: () => clientProgressDataWithStatus(projectInfoData?.project_key),
  });
  let isFinalModelQcResFound = [];
  if (clientData && clientData.length > 0) {
    isFinalModelQcResFound = clientProgressData?.filter(
      (item) => item?.client_name === clientData[0]?.clientName
    );
  } else {
    // Handle the case when clientData is undefined or empty
    console.warn("clientData is empty or undefined");
  }
  useEffect(() => {
    if (versionList?.clients?.[0]?.versions) {
      const sortedVersions = [...versionList.clients[0].versions]
        .sort()
        .reverse();
      setLatestVersion(sortedVersions[0]);
    }
  }, [versionList, setLatestVersion]);

  return (
    <div className="flex">
      {/* {JSON.stringify(versionList?.clients[0]?.versions?.sort()?.reverse()[0])} */}
      {/* {versionList?.clients[0]?.versions?.sort()?.reverse()[0]} */}
      <AccessTo role={[CM]}>
        {versionList?.clients?.map((client, index) => (
          <div key={index}>
            <p className=" font-medium text-gray-600">
              Latest Version: {client.versions[client.versions.length - 1]}
            </p>
          </div>
        ))}
      </AccessTo>
      <div className="flex mb-3">
        <AccessTo role={[FL]}>
          <CreateVersion versionList={versionList} />
        </AccessTo>
        {/* <AccessTo role={[FL]}>
          <Select
            placeholder="Select a version"
            style={{ width: 200 }}
            onChange={handleChange}
          >
            {versionList?.map((item) => (
              <Option value={item}>{item}</Option>
            ))}
          </Select>
        </AccessTo> */}
        <div>
          {/* {JSON.stringify(lockedStatus)} */}
          {lockedStatus?.locked == null ? (
            ""
          ) : (
            <AccessTo role={[CM]}>
              {lockedStatus?.locked ? (
                <button
                  disabled={isDisabled.lock}
                  className="bg-red-500 h-[28px] hover:bg-red-600 text-white text-[12.5px] px-3 rounded shadow mx-2"
                  onClick={handleLock}
                >
                  <Loader isLoading={isLoading.lock} />
                  Lock
                </button>
              ) : (
                <button
                  disabled={isDisabled.unlock}
                  className="bg-gray-500 h-[28px] hover:bg-gray-600 text-white text-[12.5px] px-3 rounded shadow  mx-2"
                  onClick={handleUnlock}
                >
                  <Loader isLoading={isLoading.unlock} />
                  Unlock
                </button>
              )}
            </AccessTo>
          )}
          {/* {JSON.stringify(isFinalModelQcResFound?.[0])} */}
          {isFinalModelQcResFound?.[0]?.final_model_qc?.resource && (
            <AccessTo role={[CM]}>
              <button
                className="bg-blue-500  h-[28px] hover:bg-blue-600 text-white text-[12.5px] px-3 rounded shadow"
                onClick={handleUpgrade}
                disabled={isDisabled.upgrade}
              >
                <Loader isLoading={isLoading.upgrade} />
                Upgrade
              </button>
            </AccessTo>
          )}
        </div>
      </div>
    </div>
  );
}

export default React.memo(VersionLockUnlock);
